import { useSelector } from 'react-redux';

export const usePermissions = () => {
  const permissions = useSelector((state) => state.permissions.permissions);
  const loading = useSelector((state) => state.permissions.loading);
  const loaded = useSelector((state) => state.permissions.loaded);

  const hasPermission = (moduleKey, permission = 'canRead') => {
    const modulePermission = permissions.find((p) => p.moduleKey === moduleKey);
    return modulePermission ? modulePermission[permission] : false;
  };

  const hasReadPermission = (moduleKey) => hasPermission(moduleKey, 'canRead');
  
  const hasWritePermission = (moduleKey) => hasPermission(moduleKey, 'canWrite');

  const canAccessModule = (moduleKey) => {
    return hasReadPermission(moduleKey) || hasWritePermission(moduleKey);
  };

  return {
    permissions,
    loading,
    loaded,
    hasPermission,
    hasReadPermission,
    hasWritePermission,
    canAccessModule
  };
};